import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";

function Minisosec() {
  useEffect(() => {
    Aos.init({});
  }, []);
  return (
    <div
      className="brand-bg2"
      style={{
        backgroundImage: "url(./assets/media/illustrations/circle.png)",
        zIndex: "-1",
        backgroundAttachment: "fixed",
        opacity: "1",
      }}
    >
      <div className="container">
        <div className="d-flex">
          <div className="min-h-350px min-h-lg-500px px-10">
            <div className="text-justify mb-2 mt-8 mb-lg-2 d-sm-block py-10 py-lg-20 ">
              {/* <img
                src={"./resources/img/Miniso.png"}
                alt='miniso'
                className='mb-6'
                width='120px'
                height='60px'
              ></img> */}
              <h4 className="fs-3x fs-lg-3x mb-2">
                Miniso Franchise <br></br>Opportunity
              </h4>
              {/* <div className='lineBefore mb-6'></div> */}
              <p className="my-12 col-md-12">
                Miniso is a Japanese lifestyle retail chain in over 50
                Countries. To subscribe to this guaranteed 45% Return on
                Investment annually, call 3rdRetail on{" "}
                <strong>09060002731</strong>
              </p>

              {/* <a href='#contact' className='btn btn-lg getstartedBtn'>
                Contact Us
              </a> */}
            </div>
          </div>

          <div
            className="d-none d-lg-block d-md-block col-md-4"
            data-aos="flip-right"
            data-aos-duration="3000"
          >
            <img
              src={"./resources/img/minisohead.png"}
              className={"img-fluid mt-8"}
              alt="animate"
              width="950px"
              height="982px"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Minisosec;
